import { useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { routeChanged } from "store/router/router.actions";
const RouteObserver = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(routeChanged({
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
            key: location.key,
        }));
    }, [dispatch, location.pathname, location.search, location.hash, location.key]);
    return null;
};
export default RouteObserver;
